import { call, put, takeEvery } from 'redux-saga/effects';
import toast from 'react-hot-toast';
import { SAVE_LEGAL_TEMPLATE_FORM_FIELD_DETAILS_API_URL } from '../../../../constants/ApiUrlConstants';
import { SAVE_LEGAL_TEMPLATE_FORM_FIELD_DETAILS_REQUEST } from '../../../../constants/ActionNameConstants';
import { postApiRequest } from '../../../../features/axiosClient';
import {
  saveOrUpdateTemplateFormDetailsFailure,
  saveOrUpdateTemplateFormDetailsSuccess,
} from '../actions/settingsActions';
import { getLegalTemplateFormFieldDetailsRequest } from '../actions/slateDataActions';

const saveOrUpdateTemplateFormDetails = (action) =>
  postApiRequest(SAVE_LEGAL_TEMPLATE_FORM_FIELD_DETAILS_API_URL, action);

function* saveOrUpdateTemplateFormDetailsSaga(action) {
  const { audioFileId, legalTemplateName, cgaType } = action.payload;
  try {
    const response = yield call(saveOrUpdateTemplateFormDetails, {
      id: action.payload.id,
      legalTemplateId: action.payload.legalTemplateId,
      audioFileId,
      submissionJson: action.payload.submissionJson,
      createdBy: action.payload.createdBy,
      isDeleted: action.payload.isDeleted,
    });
    if (response?.data?.errorMessage !== '' && !response.data?.success) {
      toast.error(response?.data?.errorMessage);
      yield put(saveOrUpdateTemplateFormDetailsFailure(response?.data?.errorMessage));
    }
    yield put(getLegalTemplateFormFieldDetailsRequest({ audioFileId, legalTemplateName, cgaType }));
    yield put(saveOrUpdateTemplateFormDetailsSuccess(response.data.value));
  } catch (error) {
    yield put(saveOrUpdateTemplateFormDetailsFailure(error.message));
  }
}

export function* watchSaveOrUpdateTemplateFormDetails() {
  yield takeEvery(SAVE_LEGAL_TEMPLATE_FORM_FIELD_DETAILS_REQUEST, saveOrUpdateTemplateFormDetailsSaga);
}
